import React from "react";
import { Link } from "react-router-dom";
import "./VaidikVidhya.css";
import coursesData from "../../data/coursesData";

const CoursesSection = () => {
  return (
    <section className="courses-section">

      <div className="vv-container">

        <div className="section-title">

          <span>Courses Offered</span>

          <h2>Learn Ancient Vedic Sciences</h2>
  <div className="about-heading-line">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                alt="Heading decoration"
              />
            </div>
          <p>
            Explore our professionally designed spiritual courses and master
            Numerology, Astrology, Vastu and Sacred Sciences from beginner to
            advanced level.
          </p>

        </div>

        <div className="courses-grid">

          {coursesData.map((course) => (

            <div className="course-card" key={course.id}>

              <div className="course-image">

                <img src={course.image} alt={course.title} />

              </div>

              <div className="course-content">

                <h3>{course.title}</h3>

                <p>{course.shortDescription}</p>

                <ul>

                  {course.features.slice(0,3).map((item,index)=>(

                    <li key={index}>✔ {item}</li>

                  ))}

                </ul>

                <Link
                  to={`/course/${course.slug}`}
                  className="course-btn"
                >
                 Coming Soon... 
                </Link>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
};

export default CoursesSection;